import {Button, Checkbox} from "parts";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import {scrollIntoViewWithOffset, setTrack} from "../../utils";


export function Error({onRetry, onCancel}) {
  const
    {t} = useTranslation('common', {keyPrefix: 'payment.error'})

  useEffect(() => {
    document.body.classList.add('pop')

    return () => document.body.classList.remove('pop')
  }, [])

  const handleRetry = () => {
    setTrack('retry_error')

    if (onRetry)
      onRetry()
  }

  const handleCancel = () => {
    setTrack('cancel_error')

    if (onCancel)
      onCancel()

    scrollIntoViewWithOffset('#payment', 48)
  }

  return (
    <>
      <div className="shadow" style={{backgroundColor: 'var(--bg-100)'}}/>
      <div className={'window adaptive items center h-100 gap-0 scrollable'} style={{backgroundColor: 'transparent'}}>
        <img className={'mt-auto'} width={350} height={200} alt="" src={'/static/img/paywall/error.svg'}
             onError={e => e.currentTarget.style.opacity = '0'}
        />

        <div className={'surface items center text-center mb-4'} style={{backgroundColor: '#28222B', padding: 20}}>
          <h3>{t('header')}</h3>
          <p className="notice small">{t('desc')}</p>

          <div className={'stack gap-3 text-start'}>
            {
              t('list').split('\n').map(item =>
                <div key={item} className={'row gap-3'}>
                  <Checkbox type={'checkbox'} checked={true} disabled={true}
                            className={'disabled success'} style={{backgroundColor: '#3ED06A'}}/>
                  <small className={'notice'}>{item}</small>
                </div>
              )
            }
          </div>
        </div>

        <Button size={'lg'} className="btn-shadow w-100 mt-auto mb-4" onClick={handleRetry}>{t('retry')}</Button>
        <Button variant={'outline-danger'} size={'lg'} className="w-100" onClick={handleCancel}>{t('cancel')}</Button>
      </div>
    </>
  )
}